import React, { Component } from 'react';

class FA extends Component {
  constructor(props) {
    super(props);

    this.state = { saved: this.props.saved || false };
  }

  render() {
    var className="fa fa-"+this.props.name;
    return (
      <i className={className}></i>
    );
  }
}

export { FA };
